export const OPENED_LANDING_PAGE = "OPENED_LANDING_PAGE" as const;
export const STARTED_SURVEY = "STARTED_SURVEY" as const;
